import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}

import { ref, computed, onMounted } from 'vue';
import Modal from '@/shared/components/Modal.vue';
import { ADD_FLOW } from '@/store/bot-designer/paths/mutationTypes';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import { flowsApi } from '@/features/bots/services/flows';
import Toast from '../services/toast';
import appInsights from '../services/appInsights';
import useVuelidate from '@vuelidate/core';
import { required, maxLength } from '@vuelidate/validators';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddFlowModal',
  emits: ["flow-added", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useStore();

const currentWorkspace = computed(() => store.getters.currentWorkspace);
const addFlowToList = (path: FlowListItemViewModel) => store.commit(ADD_FLOW, path);

const flowName = ref('');
const isLoading = ref(false);
const addFlowInput = ref<HTMLInputElement | null>(null);

// Validation rules for the flowName
const validations = {
  flowName: {
    required,
    maxLength: maxLength(50),
    flowNameValid: VuelidateUtil.objectName,
  },
};

const $v = useVuelidate(validations, { flowName });

onMounted(() => {
  if (addFlowInput.value) {
    addFlowInput.value.focus();
  }
});

async function addFlow() {
  if ($v.value.$invalid) {
    return;
  }

  appInsights.trackEvent({ name: 'Add flow clicked' }, { workspaceId: currentWorkspace.value.id });
  isLoading.value = true;
  try {
    const flowItem = await flowsApi.addFlow(currentWorkspace.value.id, { name: flowName.value });
    addFlowToList(flowItem);
    isLoading.value = false;
    emit('flow-added', flowItem);
    close();
  } catch (e: any) {
    isLoading.value = false;
    if (e.status === 409) {
      Toast.showError(e.message);
      return;
    }
    Toast.showError('Failed to add flow');
  }
}

function getErrorMessage(): string {
  if ($v.value.flowName.required && !$v.value.flowName.flowNameValid) {
    return 'Name must only contain letters, numbers, spaces, and the characters , - _ ( ) &';
  }
  if (!$v.value.flowName.maxLength) {
    return 'Name must not be longer than 50 characters';
  }
  if (!$v.value.flowName.required) {
    return 'Name must not be empty';
  }

  return '';
}

function close() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: close }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Add a new flow", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "flow-modal-name-input",
          class: "label"
        }, "Flow Name", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "flow-modal-name-input",
            ref_key: "addFlowInput",
            ref: addFlowInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((flowName).value = $event)),
            class: _normalizeClass(["input", { 'is-danger': _unref($v).flowName.$invalid && _unref($v).flowName.$dirty }]),
            type: "text",
            placeholder: "Enter the Flow Name...",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).flowName.$touch())),
            onKeypress: _withKeys(addFlow, ["enter"])
          }, null, 34), [
            [_vModelText, flowName.value]
          ]),
          (_unref($v).flowName.$invalid && _unref($v).flowName.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getErrorMessage()), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: addFlow,
            disabled: _unref($v).$invalid,
            loading: isLoading.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Add")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            onClick: close,
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})